import { render, staticRenderFns } from "./EWCountryList.vue?vue&type=template&id=60971f47&"
import script from "./EWCountryList.vue?vue&type=script&lang=js&"
export * from "./EWCountryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports